import { useState } from 'react';
import { ThumbsDown, ThumbsUp } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../ui/table';
import { formatDate, scoreTone } from '../qualityConfig';

export const ReportByUserTable = ({ rows, onOpenUser }) => (
    <Card className="overflow-hidden" data-testid="report-by-user">
        <CardHeader className="pb-2"><CardTitle className="font-heading text-lg">Recruiter breakdown</CardTitle></CardHeader>
        <Table>
            <TableHeader><TableRow>
                <TableHead>Recruiter</TableHead><TableHead>Tasks</TableHead><TableHead>Completed</TableHead><TableHead>Missed</TableHead>
                <TableHead>Open</TableHead><TableHead>Not opened</TableHead><TableHead>Simulations done</TableHead><TableHead>Avg score</TableHead><TableHead>Helpful</TableHead>
            </TableRow></TableHeader>
            <TableBody>
                {rows.map((r) => (
                    <TableRow key={r.user_id} className="cursor-pointer" onClick={() => onOpenUser({ id: r.user_id, name: r.user_name, department: r.department })} data-testid={`report-user-row-${r.user_id}`}>
                        <TableCell><p className="font-medium">{r.user_name}</p><p className="text-xs text-muted-foreground">{r.department || r.user_email}</p></TableCell>
                        <TableCell className="tabular-nums">{r.total}</TableCell>
                        <TableCell className="tabular-nums text-emerald-600 dark:text-emerald-400">{r.completed}</TableCell>
                        <TableCell className="tabular-nums text-rose-600 dark:text-rose-400">{r.missed}</TableCell>
                        <TableCell className="tabular-nums">{r.open}</TableCell>
                        <TableCell className={`tabular-nums ${r.not_opened ? 'font-semibold text-rose-600 dark:text-rose-400' : ''}`} data-testid={`report-user-not-opened-${r.user_id}`}>{r.not_opened}</TableCell>
                        <TableCell className="font-mono text-xs tabular-nums">{r.sims_completed}/{r.sims_assigned}</TableCell>
                        <TableCell className={`font-heading text-base font-bold tabular-nums ${scoreTone(r.avg_score)}`} data-testid={`report-user-avg-${r.user_id}`}>{r.avg_score ?? '—'}</TableCell>
                        <TableCell>
                            <span className="inline-flex items-center gap-2 text-xs">
                                <span className="inline-flex items-center gap-0.5 text-emerald-600"><ThumbsUp className="h-3 w-3" />{r.helpful_yes}</span>
                                <span className="inline-flex items-center gap-0.5 text-rose-600"><ThumbsDown className="h-3 w-3" />{r.helpful_no}</span>
                            </span>
                        </TableCell>
                    </TableRow>
                ))}
                {rows.length === 0 && <TableRow><TableCell colSpan={9} className="py-10 text-center text-muted-foreground">No tasks were assigned in this period</TableCell></TableRow>}
            </TableBody>
        </Table>
    </Card>
);

const FILTERS = [{ id: 'all', label: 'All' }, { id: 'yes', label: 'Helpful' }, { id: 'no', label: 'Not helpful' }];

export const ReportFeedbackList = ({ items }) => {
    const [filter, setFilter] = useState('all');
    const shown = items.filter((f) => filter === 'all' || (filter === 'yes') === f.helpful);
    return (
        <Card data-testid="report-feedback">
            <CardHeader className="flex flex-row flex-wrap items-center justify-between gap-2 pb-2">
                <CardTitle className="font-heading text-lg">Recruiter feedback</CardTitle>
                <div className="flex gap-1.5">
                    {FILTERS.map((f) => (
                        <button key={f.id} type="button" onClick={() => setFilter(f.id)} data-testid={`report-feedback-filter-${f.id}`}
                            className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors ${filter === f.id ? 'border-violet-500 bg-violet-600 text-white' : 'hover:bg-muted'}`}>{f.label}</button>
                    ))}
                </div>
            </CardHeader>
            <CardContent className="grid gap-3 md:grid-cols-2">
                {shown.map((f) => (
                    <div key={f.task_id} className="rounded-xl border p-4" data-testid={`report-feedback-${f.task_id}`}>
                        <p className="flex items-center gap-2 text-sm font-medium">
                            {f.helpful ? <ThumbsUp className="h-4 w-4 text-emerald-600" /> : <ThumbsDown className="h-4 w-4 text-rose-600" />}
                            {f.user_name}<span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">{formatDate(f.submitted_at)}</span>
                        </p>
                        <p className="mt-0.5 truncate text-xs text-muted-foreground">{f.task_title}</p>
                        <p className="mt-2 text-sm">“{f.comment}”</p>
                    </div>
                ))}
                {shown.length === 0 && <p className="col-span-full py-6 text-center text-sm text-muted-foreground">No feedback in this view yet.</p>}
            </CardContent>
        </Card>
    );
};
